/**
 * These are the colors for Project. It can attach one these color to project while creating it. Color of the project icon is dependent on this color.
 * @type {string[]}
 */
export const PROJECT_PALETTE = [
  '3A84BB',
  '377D50',
  'A8D14B',
  '7DC4A4',
  'F0C052',
  'D1505F',
  '9960D5',
  '80CAFA',
  '795549',
  'EC66C0',
  'ED6E40',
  '5A5D65'
]
